import { NOTE_SLICER_WIDGET, NoteSlicer } from './note-slicer';

export function effects() {
  customElements.define(NOTE_SLICER_WIDGET, NoteSlicer);
}
